import React from 'react';

import { Notification } from '../../types/notification';
import { Card } from '../ui/card';

import { SystemAlertItem } from './items/SystemAlertItem';
import { ZTPRequestItem } from './items/ZTPRequestItem';

interface NotificationListProps {
  notifications: Notification[];
  onAction: (notification: Notification, handlerId: string) => void;
}

const GenericItem: React.FC<{ notification: Notification }> = ({
  notification,
}) => (
  <Card className='mb-4 p-4'>
    <h4 className='font-semibold'>{notification.title}</h4>
    <p className='text-sm text-gray-500'>{notification.description}</p>
  </Card>
);

export const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
  onAction,
}) => {
  return (
    <div className='space-y-4'>
      {notifications.map(notification => {
        // Strategy Pattern for rendering
        switch (notification.type) {
          case 'ZTP_REQUEST':
            return (
              <ZTPRequestItem
                key={notification.id}
                notification={notification}
                onAction={onAction}
              />
            );
          case 'SYSTEM_ALERT':
            return (
              <SystemAlertItem
                key={notification.id}
                notification={notification}
                onAction={onAction}
              />
            );
          default:
            return (
              <GenericItem key={notification.id} notification={notification} />
            );
        }
      })}
    </div>
  );
};
